import { Suspense } from "react"
import { useTranslation } from "react-i18next"
import { UserRole, useUser } from "@/apis/bff"
import { ScrollWrapper } from "@/components/scroll-wrapper"
import { Header } from "@/layouts/header"
import { AtossFileUploadCard } from "@/modules/admin/capacity/components/atoss-file-upload-card"
import { DisableNewChatsCard } from "@/modules/admin/capacity/components/disabled-new-chats-card"
import { ForecastFileUploadCard } from "@/modules/admin/capacity/components/forecast-file-upload-card"
import { SteeringLevelCard } from "@/modules/admin/capacity/components/steering-level-card"

const RoleBasedComponents = ({ role }: { role: UserRole }) => {
  if (role === "MedicalSupervisor") {
    return (
      <div className="grid gap-4">
        <div className="flex gap-4">
          <ForecastFileUploadCard />
          <AtossFileUploadCard />
        </div>
        <div className="flex gap-4">
          <SteeringLevelCard />
          <DisableNewChatsCard isMedical={true} />
          <DisableNewChatsCard isMedical={false} />
        </div>
      </div>
    )
  } else {
    return (
      <div className="grid gap-4">
        <SteeringLevelCard />
      </div>
    )
  }
}

const Capacity = () => {
  const { t } = useTranslation()
  const { role } = useUser()

  return (
    <>
      <Header title={t("admin.capacity.pageTitle")} />
      <div className="grid-cols-1fr-auto bg-background-subdued grid grid-rows-1" data-testid="capacity-page">
        <ScrollWrapper className="scrollbar-w-1 hover:scrollbar-thumb-surface-pressed scrollbar-track-transparent p-8">
          <Suspense>
            <RoleBasedComponents role={role} />
          </Suspense>
        </ScrollWrapper>
      </div>
    </>
  )
}

export { Capacity }
